import React from "react";

const logline = <p>
    An absentee father and his estranged son get lost while hiking in the wilderness.  The father breaks his ankle, and the son must decide whether to leave to save himself (like his father left him)  or stay and risk his life for this man he still loves.
    </p>;

export default logline;